import React from 'react';
import t from 'react-translate';
import { config } from '@config/pendo.config.json';
import NvEmoji from 'shared/components/nv-emoji';
import AiGeneratingLoader from 'lecture_pages/components/left-panel/novo-ai/components/shared/ai-generating-loader';
import { LoaderType } from 'shared/components/loading-placeholder';
import QuestionText from './question-text';
import { loadingDrawerState } from '../styles';
import FormattedAnswer from './formatted-answer';

interface LoadingDrawerStateProps {
  question?: string;
  partialAnswer?: string;
  statusMessage?: string;
  onCancel?: () => void;
}

const LoadingDrawerState = ({
  question,
  partialAnswer,
  statusMessage,
  onCancel,
}: LoadingDrawerStateProps) => {
  const hasPartialAnswer = !!partialAnswer?.trim();
  const formattedStatusMessage = statusMessage?.trim().replace(/(\.{1,3}|…)$/, '');

  return (
    <div css={loadingDrawerState}>
      <NvEmoji icon='light' size='large' />
      <QuestionText question={question} />
      {hasPartialAnswer ? (
        <FormattedAnswer answer={partialAnswer} />
      ) : (
        <>
          <div className='loading-icon'>
            <AiGeneratingLoader loaderType={LoaderType.ICON_ONLY} />
          </div>
          {formattedStatusMessage && (
            <p className='stream-status'>{formattedStatusMessage}...</p>
          )}
        </>
      )}
      <button type='button' onClick={onCancel} data-qa={config.pendo.aiLearning.cancelButton}>{t.FORM.CANCEL()}</button>
    </div>
  );
};

export default LoadingDrawerState;
